import itemId from 'owa-service/lib/factory/itemId';
import addTrustedSenderOperation from 'owa-service/lib/operation/addTrustedSenderOperation';

export default function addTrustedSender(id: string) {
    return addTrustedSenderOperation({
        itemId: itemId({
            Id: id,
        }),
    });
}
